export enum PetType {
    Dogs = 'Dogs',
    Cats = 'Cats',
}

export enum CautionMoneyType {
    FixedAmount = 'FixedAmount',
    PerPersonPerNight = 'PerPersonPerNight',
    PercentOfReservation = 'PercentOfReservation',
}

interface PetsPolicy {
    types: PetType[];
    price: number;
    weightLimit: number | null;
}

interface CautionMoneyPolicy {
    amount: number;
    type: CautionMoneyType;
}

export interface PolicyModel {
    pets: PetsPolicy | null;
    cautionMoney: CautionMoneyPolicy | null;
}
